import axios from "axios";
import { API_URL, FOLDERPATH } from "../Constants/config";
import { toast } from "react-toastify";
import {
    ONBOARDING_DETAILS_LOADING,
    ONBOARDING_DETAILS_SUCCESS,
    ONBOARDING_DETAILS_FAILED,
    SAVE_ONBOARDING_DETAILS_SUCCESS,
    SAVE_ONBOARDING_DETAILS_LOADING,
    SAVE_ONBOARDING_DETAILS_FAILED
  } from "../Constants/onboardingDetailsConstants";

export const getOnboardingDetails = () => async (dispatch) => {
  try {

    dispatch({ type: ONBOARDING_DETAILS_LOADING });

    let userLocalData = JSON.parse(localStorage.getItem('userVerificationCandidate'));  

    const requestData = {
      token: userLocalData.id
    };

    //return false;
    const headers = {
      "Content-Type": "application/json",
      "Username": "ibridge",
      "Password": "ibridge@2020",
    };

    //axios.defaults.baseURL = API_URL;

    const { data } = await axios.post(FOLDERPATH + "/NewSigndriveApi/onboardingDetail", requestData, {
        headers,
     });
     
     console.log("sas",data);

     if (data.status === "success") {

    dispatch({
      type: ONBOARDING_DETAILS_SUCCESS,
      payload: data,
    });

  }else{

    // dispatch({
    //   type: AUTHORIZATION_FAILED,
    //   payload: data
    // });

    const msg = data.message;

    toast.dismiss();

    toast.error(msg, {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

    let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
    userLocalData.auth_complete = 1;

    console.log(userLocalData);

    localStorage.setItem("userVerificationCandidate", JSON.stringify(userLocalData));
    window.location.reload();

  }

  } catch (error) {
    dispatch({
      type: ONBOARDING_DETAILS_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });
  }
};

export const SaveOnboardingDetails = (payload, callback=()=>{}) => async (dispatch) => {
  try {

    dispatch({ type: SAVE_ONBOARDING_DETAILS_LOADING });

    let userLocalData = JSON.parse(localStorage.getItem('userVerificationCandidate'));  

    const requestData = {
      token: userLocalData.id,
      ...payload
    };

    //return false;
    const headers = {
      "Content-Type": "application/json",
      "Username": "ibridge",
      "Password": "ibridge@2020",
    };

    //axios.defaults.baseURL = API_URL;
    // https://ibridge-uat.authbridge.com/idemo/NewSigndriveApi/saveOnboardingDetail


    const { data } = await axios.post(FOLDERPATH + "/NewSigndriveApi/saveOnboardingDetail", requestData, {
        headers,
     });
     
     console.log("sas",data);

     if (data.success === "1") {

    dispatch({
      type: SAVE_ONBOARDING_DETAILS_SUCCESS,
      payload: data,
    });
    callback(data?.data);

  }else{

    // dispatch({
    //   type: AUTHORIZATION_FAILED,
    //   payload: data
    // });

    const msg = data.message;

    toast.dismiss();

    toast.error(msg, {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

    let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
    userLocalData.auth_complete = 1;

    console.log(userLocalData);

    localStorage.setItem("userVerificationCandidate", JSON.stringify(userLocalData));
    window.location.reload();

  }

  } catch (error) {
    dispatch({
      type: SAVE_ONBOARDING_DETAILS_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });
  }
}
